export default __webpack_public_path__ + "static/media/booking.8c51dc7e.svg";